import {BaseModel} from "../base";
import {person} from "../../services/person";
import {AdminServiceModel} from "../admin/service";
import {AdminResourceModel} from "../admin/resource";

class PersonModel extends BaseModel {

    /**
     * @description
     * Static function that loads an array of people from a company object
     *
     * @returns {promise} A returned promise
     */
    static $query(company) {
        return person.query(company);
    }
    $getEnabledServices() {
        return this.$get('enabled_services').then((services) => {
            return services.map((service) => {
                return new AdminServiceModel(service);
            });
        });
    }

    $getEnabledResources() {
        return this.$get('enabled_resources').then((resources) => {
            return resources.map((resource) => {
                return new AdminResourceModel(resource);
            });
        });
    }
}

export {
    PersonModel
}